import { type FC } from "react";
import { Input } from "~/shared/ui/input";
import { cn } from "~/shared/lib/utils";
import { FILTER_FIELD_CLASS } from "./filter-field-primitives";

/** Parses stored number_range value: "min:5", "max:100", "min:5:max:100", or undefined */
export function parseNumberRangeValue(val: unknown): { min?: number; max?: number } {
    if (!val || typeof val !== "string") return {};
    const result: { min?: number; max?: number } = {};
    const minMatch = /min:(\d+)/.exec(val);
    const maxMatch = /max:(\d+)/.exec(val);
    if (minMatch) result.min = Number(minMatch[1]);
    if (maxMatch) result.max = Number(maxMatch[1]);
    return result;
}

export const NumberRangeFilter: FC<{
    value: string;
    onChange: (value: string | undefined) => void;
    labels?: { min?: string; max?: string };
}> = ({ value, onChange, labels }) => {
    const parsed = parseNumberRangeValue(value);

    const buildValue = (min: string, max: string): string | undefined => {
        const parts: string[] = [];
        if (min) parts.push(`min:${min}`);
        if (max) parts.push(`max:${max}`);
        return parts.length > 0 ? parts.join(":") : undefined;
    };

    return (
        <div className="flex gap-1.5">
            <Input
                type="number"
                min={0}
                max={parsed.max}
                value={parsed.min !== undefined ? String(parsed.min) : ""}
                onChange={(e) => {
                    const v = e.target.value.replace(/\D/g, "");
                    const num = v ? Number(v) : undefined;
                    const clamped =
                        num !== undefined && parsed.max !== undefined && num > parsed.max
                            ? String(parsed.max)
                            : v;
                    onChange(buildValue(clamped, parsed.max !== undefined ? String(parsed.max) : ""));
                }}
                placeholder={labels?.min ?? "Min"}
                className={cn("h-9 w-0 flex-1 !px-3", FILTER_FIELD_CLASS)}
            />
            <Input
                type="number"
                min={parsed.min ?? 0}
                value={parsed.max !== undefined ? String(parsed.max) : ""}
                onChange={(e) => {
                    const v = e.target.value.replace(/\D/g, "");
                    const num = v ? Number(v) : undefined;
                    const clamped =
                        num !== undefined && parsed.min !== undefined && num < parsed.min
                            ? String(parsed.min)
                            : v;
                    onChange(buildValue(parsed.min !== undefined ? String(parsed.min) : "", clamped));
                }}
                placeholder={labels?.max ?? "Max"}
                className={cn("h-9 w-0 flex-1 !px-3", FILTER_FIELD_CLASS)}
            />
        </div>
    );
};
